// extracted by mini-css-extract-plugin
export default {"aboutHeading":"About_aboutHeading__RHFxa","aboutContainer":"About_aboutContainer__Scy5E"};